/**
 * Sparkle star used in the reward burst animation. Six of these are
 * arranged in a radial pattern around the coin and staggered in time.
 *
 * Rendered as a stand-alone component (not embedded in CoinIcon) so
 * CoinBurst can animate the group with keyframes without having to peer
 * inside a monolithic SVG.
 */
export interface CoinSparkleProps {
  size?: number;
  className?: string;
  /** Optional fill override. Default is a warm gold. */
  color?: string;
}

export function CoinSparkle({ size = 18, className, color = '#FCD34D' }: CoinSparkleProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      focusable={false}
    >
      {/* Four-point star — two overlapping slim diamonds rotated 45°.
          Pure geometry, no gradient, so it pops cleanly against any
          background without worrying about contrast tuning. */}
      <path
        d="M12 2 L13.4 10.6 L22 12 L13.4 13.4 L12 22 L10.6 13.4 L2 12 L10.6 10.6 Z"
        fill={color}
      />
    </svg>
  );
}
